var map = {
	"./box1.png": "l0Cz",
	"./box2.png": "TqQg",
	"./box3.png": "B+MV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eHYz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy ^\.\/box.*\.png$
// module id = eHYz
// module chunks = 0